import type { ReactNode } from 'react';

import { InputAdornment, TextField } from '@mui/material';

import { FieldRow } from './FieldRow';

export interface NumberFieldProps {
  label: ReactNode;
  description?: ReactNode;
  value: number | null;
  onChange: (value: number | null) => void;
  disabled?: boolean;
  min?: number;
  max?: number;
  /** Trailing unit label, e.g. "minutes". */
  suffix?: string;
  placeholder?: string;
}

/** Labelled nullable integer input laid out as a settings row. */
export function NumberField({
  label,
  description,
  value,
  onChange,
  disabled = false,
  min,
  max,
  suffix,
  placeholder,
}: NumberFieldProps) {
  return (
    <FieldRow label={label} description={description}>
      <TextField
        size="small"
        type="number"
        value={value ?? ''}
        placeholder={placeholder}
        disabled={disabled}
        onChange={(event) => {
          const raw = event.target.value;
          onChange(raw === '' ? null : Number(raw));
        }}
        sx={{ maxWidth: 220 }}
        slotProps={{
          htmlInput: { min, max, 'aria-label': typeof label === 'string' ? label : undefined },
          input: suffix
            ? { endAdornment: <InputAdornment position="end">{suffix}</InputAdornment> }
            : undefined,
        }}
      />
    </FieldRow>
  );
}
